const fadeIn = {
  fromStyle: { opacity: 0, transform: 'translateX(-200%)' },
  toStyle: { opacity: 0.85, transform: 'translateX(-50%)' },
  easing: 'easeOutBack'
};

const fadeOut = {
  fromStyle: { opacity: 0.85, transform: 'translateX(-50%)' },
  toStyle: { opacity: 0, transform: 'translateX(200%)' },
  easing: 'easeOutBack'
}


export default [
  {
    text: {
		'en': "Vanessa moves to Oakland, California in 1986 along with her young son to start a new chapter in life. She meets her husband Richard while attending church, and the two marry in 1988.",
		'es': "Vanessa se muda a Oakland, California en 1986 junto con su hijo pequeño para comenzar un nuevo capítulo en la vida. Conoce a su esposo Richard mientras asistía a la iglesia y los dos se casan en 1988."
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/A.png',
    parallaxData: {
      start: 2200,
      end: 2300,
      ...fadeOut
    }
  },
  {
    text: {
		'en': "After the birth of her second child, Vanessa's sister-in-law gifts the couple money for a home down-payment. Vanessa and Richard buy and move into their first home in the summer of 1992, where they define their own 'American Dream'.",
		'es': "Después del nacimiento de su segundo hijo, la cuñada de Vanessa les regala dinero a la pareja para el pago inicial de la casa. Vanessa y Richard compran y se mudan a su primera casa en el verano de 1992, donde definen su propio 'sueño americano'."
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/A.png',
    parallaxData: [
      {
        start: 2300,
        end: 2400,
        ...fadeIn
      },
      {
        start: 3200,
        end: 3300,
        ...fadeOut
      }
    ]
  },
  {
    text: {
		'en': "Vanessa loves the stability their new home offers, inspiring her to go back to school and earn a Bachelor's degree in Child Development. She begins a successful child-care business run in her own home, while pregnant with her last child.",
		'es': "A Vanessa le encanta la estabilidad que ofrece su nuevo hogar, lo que la inspira a volver a la escuela y obtener una licenciatura en desarrollo infantil. Ella comienza un exitoso negocio de cuidado de niños en su propia casa, mientras está embarazada de su último hijo."
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/A.png',
    parallaxData: [
      {
        start: 3200,
        end: 3300,
        ...fadeIn
      },
      {
        start: 5100,
        end: 5200,
        ...fadeOut
      },
    ]
  },
  {
    text: {
		'en': "Now as a second source of income and personal livelihood, Vanessa's home is a haven for both her family and her surrounding community for the next 20 years.",
		'es': "Ahora, como segunda fuente de ingresos y sustento personal, la casa de Vanessa es un refugio tanto para su familia como para la comunidad que la rodea durante los próximos 20 años."
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/A.png',
    parallaxData: [
      {
        start: 5200,
        end: 5300,
        ...fadeIn
      },
      {
        start: 7100,
        end: 7200,
        ...fadeOut
      },
    ]
  },
  {
    text: {
		'en': "However, things soon take a turn. In 2008, Vanessa's husband suffers a massive stroke. That same year, the housing market crashes.",
		'es': "Sin embargo, las cosas pronto dan un giro. En 2008, el esposo de Vanessa sufre un derrame cerebral masivo. Ese mismo año, el mercado de la vivienda colapsa"
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/B.png',
    parallaxData: [
      {
        start: 7200,
        end: 7300,
        ...fadeIn
      },
      {
        start: 9600,
        end: 9700,
        ...fadeOut
      },
    ]
  },
  {
    text: {
		'en': "Between recovery and rehabilitation, Vanessa's husband loses his job and the family's second stream of income. Vanessa is now the family's sole financial provider.",
		'es': "Entre la recuperación y la rehabilitación, el esposo de Vanessa pierde su trabajo y la segunda fuente de ingresos de la familia. Vanessa es ahora el único proveedor financiero de la familia"
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/B.png',
    parallaxData: [
      {
        start: 9700,
        end: 9800,
        ...fadeIn
      },
      {
        start: 11500,
        end: 11600,
        ...fadeOut
      },
    ]
  },
  {
    text: {
		'en': "Vanessa and Richard attempt to secure a loan modification to ease their financial strain to no avail. Life soon begins to feel like a maze of run-arounds and roadblocks created by the banks themselves.",
		'es': "Vanessa y Richard intentan en vano obtener una modificación de préstamo para aliviar su tensión financiera. La vida pronto comienza a sentirse como un laberinto de evasivas y obstáculos creados por los propios bancos."
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/B.png',
    parallaxData: [
      {
        start: 11600,
        end: 11700,
        ...fadeIn
      },
      {
        start: 14500,
        end: 14600,
        ...fadeOut
      },
    ]
  },
  {
    text: {
		'en': "While trying to navigate a series of dead ends, Vanessa and Richard had their home of 20 years taken by the banks in December of 2012.",
		'es': "Mientras trataban de navegar por una serie de callejones sin salida, los bancos tomaron su casa de 20 años de Vanessa y Richard en diciembre de 2012."
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/B.png',
    parallaxData: [
      {
        start: 14600,
        end: 14700,
        ...fadeIn
      },
      {
        start: 16200,
        end: 16300,
        ...fadeOut
      },
    ]
  },
  {
    text: {
		'en': "Even worse, it's not just Vanessa and her husband going through foreclosure. In fact, nearly 35 homes in the neighborhood have already been foreclosed on...all within a 6 block radius.",
		'es': "Peor aún, no solo Vanessa y su esposo están pasando por una ejecución hipotecaria. De hecho, casi 35 casas en el vecindario ya han sido embargadas... todas dentro de un radio de 6 cuadras."
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/B.png',
    parallaxData: [
      {
        start: 16300,
        end: 16400,
        ...fadeIn
      },
      {
        start: 20200,
        end: 20300,
        ...fadeOut
      },
    ]
  },
  {
    text: {
		'en': "Leaving behind many memories and mementos, they pack up Vanessa's childcare business, and with that, lose many of her clientele. It's feels like starting from scratch all over again.",
		'es': "Dejando atrás muchos recuerdos y recuerdos, empaquetan el negocio de cuidado de niños de Vanessa y, con eso, pierden gran parte de su clientela. Se siente como empezar desde cero de nuevo."
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/B.png',
    parallaxData: [
      {
        start: 20200,
        end: 20300,
        ...fadeIn
      },
      {
        start: 23300,
        end: 23400,
        ...fadeOut
      },
    ]
  },
  {
    text: {
		'en': "Vanessa and Richard find a new home to rent via the property management company Waypoint Homes. Not only can this new home accomodate Vanessa's child-care business, but it also has a rent-to-own program. There's hope they can one day own again.",
		'es': "Vanessa y Richard encuentran una nueva casa para alquilar a través de la empresa de administración de propiedades Waypoint Homes. Esta nueva casa no solo puede acomodar el negocio de cuidado de niños de Vanessa, sino que también tiene un programa de alquiler con opción a compra. Hay esperanza de que algún día puedan volver a ser dueños."
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/C.png',
    parallaxData: [
      {
        start: 23400,
        end: 23500,
        ...fadeIn
      },
      {
        start: 27300,
        end: 27400,
        ...fadeOut
      },
    ]
  },
  {
    text: {
		'en': "The following year, Vanessa applies for \"City Slickers\", a program dedicated to teaching kids how to garden. As part of their routine process, they test her soil and find extremely high levels of lead. It's unsafe for kids to play in the backyard...or for Vanessa to even run her business.",
		'es': "Al año siguiente, Vanessa aplica para \"City Slickers\", un programa dedicado a enseñar a los niños a cuidar el jardín. Como parte de su proceso de rutina, analizan su suelo y encuentran niveles extremadamente altos de plomo. No es seguro que los niños jueguen en el patio trasero... o que Vanessa incluso administre su negocio."
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/D.png',
    parallaxData: [
      {
        start: 27300,
        end: 27400,
        ...fadeIn
      },
      {
        start: 29300,
        end: 29400,
        ...fadeOut
      },
    ]
  },
  {
    text: {
		'en': "Vanessa reaches out to Waypoint Homes to sterilize the soil, but there is a turnover in the property management. Vanessa can't get through to anyone, and keeps running into dead ends.",
		'es': "Vanessa se acerca a Waypoint Homes para esterilizar el suelo, pero hay rotación en la administración de la propiedad. Vanessa no puede comunicarse con nadie y sigue tropezando con callejones sin salida."
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/D.png',
    parallaxData: [
      {
        start: 29400,
        end: 29500,
        ...fadeIn
      },
      {
        start: 31200,
        end: 31300,
        ...fadeOut
      },
    ]
  },
  {
    text: {
		'en': "Because Starwood Waypoint Homes did not grant Vanessa a lead remediation, she loses her income -- eventually, falling behind on rent and going to eviction court. However, with help from her church, Vanessa's able to hire an eviction attorney and wins her case.",
		'es': "Debido a que Starwood Waypoint Homes no le otorgó a Vanessa una remediación de plomo, ella pierde sus ingresos; finalmente, se atrasa en el pago del alquiler y va a la corte de desalojo. Sin embargo, con la ayuda de su iglesia, Vanessa puede contratar a un abogado de desalojo y gana su caso."
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/D.png',
    parallaxData: [
      {
        start: 31300,
        end: 31400,
        ...fadeIn
      },
      {
        start: 32500,
        end: 32600,
        ...fadeOut
      },
    ]
  },
  {
    text: {
		'en': "One day, an organizer from ACCE knocks on her door, inspiring Vanessa to attend a meeting with dozens of neighbors having issues with unethical landlords. She joins in leading a direct call to action, which gets results in less than 2 days. Vanessa feels empowered -- how can she help other homeowners find justice?",
		'es': "Un día, un organizador de ACCE llama a su puerta e inspira a Vanessa a asistir a una reunión con decenas de vecinos que tienen problemas con propietarios poco éticos. Ella se une para liderar una llamada a la acción directa, que obtiene resultados en menos de 2 días. Vanessa se siente empoderada: ¿cómo puede ayudar a otros propietarios a encontrar justicia?"
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/E.png',
    parallaxData: [
      {
        start: 33600,
        end: 33700,
        ...fadeIn
      },
      {
        start: 37200,
        end: 37300,
        ...fadeOut
      },
    ]
  },
  {
    text: {
		'en': "Vanessa's life is transformed by her organizing with ACCE, which steps up during COVID-19. She dedicates her life to helping people find and stay in decent homes. After 30 years of marrriage, she and Richard are still going strong.",
		'es': "La vida de Vanessa se transforma por ser organizadora con ACCE, que se intensifica durante el COVID-19. Dedica su vida a ayudar a las personas a encontrar y permanecer en hogares dignos. Después de 30 años de matrimonio, ella y Richard aún se mantienen fuertes"
	},
    exhibit: '/themes/rise-theme/dist/images/estate/exhibit/F.png',
    parallaxData: [
      {
        start: 37300,
        end: 37400,
        ...fadeIn
      },
      {
        start: 42000,
        end: 42100,
        ...fadeOut
      },
    ]
  },
];
